import { render, staticRenderFns } from "./GlAccountsList.vue?vue&type=template&id=323c7dc8"
import script from "./GlAccountsList.vue?vue&type=script&lang=js"
export * from "./GlAccountsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports